import { HISTORICAL_QUALIFICATION_OPTIONS } from "./tierMockData";

export function getEvaluationWindowLabel(draft) {
  if (!draft?.evaluationWindowType) return "Not configured";
  if (draft.evaluationWindowType === "ROLLING_X_MONTH_WINDOW") {
    return `Rolling ${draft.rollingWindowMonths || "?"} months`;
  }
  return "Since Last Evaluation Date";
}

export function getHistoricalQualificationSummary(draft) {
  const mode = draft?.historicalQualificationMode;
  const option = HISTORICAL_QUALIFICATION_OPTIONS.find(
    ({ value }) => value === mode
  );
  if (!option) return { value: "Not configured", description: null };

  const period =
    mode === "ENABLED"
      ? ` - Previous ${draft?.historicalQualificationMonths ?? 12} months`
      : "";
  return {
    value: `${option.label}${period}`,
    description: option.description,
  };
}
